import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom'; // Import useNavigate
import SignIn from './SignIn';
import VerifyCode from './VerifyCode';
import { getAccountByEmail } from '../services/accountService';

const AuthMgr = () => {
    const [email, setEmail] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const navigate = useNavigate();

    const handleNextStep = (email) => {
        setEmail(email);
    };

    const handleSuccess = async () => {
        try {
            // Fetch the account record by email
            const account = await getAccountByEmail(email);

            if (!account || !account.accountGuid) {
                throw new Error('Account record not found or invalid.');
            }

            // Update the session with the userGuid
            localStorage.setItem(
                'authSession',
                JSON.stringify({
                    email: account.email,
                    accountGuid: account.accountGuid,
                    isVerified: true,
                })
            );

            setIsVerified(true);

            // Navigate to the dashboard
            navigate('/dashboard');
        } catch (err) {
            console.error('Error fetching user data:', err.message);
            alert('An error occurred while signing in. Please try again.');
        }
    };

    return (
        <div>
            {/* Add header */}
            <h1 style={{ marginBottom: '20px', textAlign: 'center', fontWeight: '300' }}>Log in to Instapath</h1>

            {!email && !isVerified && <SignIn onNextStep={handleNextStep} />}
            {email && !isVerified && <VerifyCode email={email} onSuccess={handleSuccess} />}
            {isVerified && <p>Welcome! You are signed in.</p>}

            {/* Add Sign up link */}
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <Link
                    to="/pricing"
                    style={{
                        textDecoration: 'none',
                        color: '#42a5f5',
                        fontSize: '0.9rem',
                    }}
                >
                    Don’t have an account? Sign up
                </Link>
            </div>
        </div>
    );
};

export default AuthMgr;